import { Season } from '../../domain/models/season.model';
import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import {
  RETRIEVE_SEASONS,
  RETRIEVE_SEASONS_FAILURE,
  RETRIEVE_SEASONS_SUCCESS,
} from './season.action.type';

export const seasonReducer = (state: AppState, action: AnyAction): AppState => {
  switch (action.type) {
    case RETRIEVE_SEASONS:
      return retrieveSeasonsReducer(state, action);
    case RETRIEVE_SEASONS_SUCCESS:
      return retrieveSeasonsSuccessReducer(state, action);
    case RETRIEVE_SEASONS_FAILURE:
      return retrieveSeasonsFailureReducer(state, action);
    default:
      return state;
  }
};

const retrieveSeasonsReducer = (
  state: AppState,
  _action: Action<null>,
): AppState => {
  return {
    ...state,
    season: {
      ...state.season,
      isLoading: true,
    },
  };
};

export const retrieveSeasonsSuccessReducer = (
  state: AppState,
  action: Action<Season[]>,
): AppState => {
  return {
    ...state,
    season: {
      ...state.season,
      seasons: action.payload,
      isLoading: false,
    },
  };
};

export const retrieveSeasonsFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    season: {
      ...state.season,
      error: action.payload,
      isLoading: false,
    },
  };
};
